/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Meta_DescriptionInputs */

const en_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Egly Method: six science-based steps to a better golf swing, grounded in physics, anatomy, and decades of teaching at every level of the game.`)
};

const es_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El método Egly: seis pasos basados en la ciencia para un mejor swing, fundamentados en física, anatomía y décadas de enseñanza en todos los niveles del juego.`)
};

const de_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-Methode: Sechs wissenschaftlich fundierte Schritte zu einem besseren Golfschwung, basierend auf Physik, Anatomie und jahrzehntelanger Lehre auf allen Spielniveaus.`)
};

const zh_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method：以物理学、解剖学和数十年来各级别的教学经验为基础，打造更好高尔夫挥杆的六个科学步骤。`)
};

const ar_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منهج Egly: ست خطوات علمية لسوينغ غولف أفضل، متجذرة في الفيزياء والتشريح وعقود من التعليم على كل مستويات اللعبة.`)
};

const fr_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La méthode Egly : six étapes scientifiques pour un meilleur swing de golf, fondées sur la physique, l'anatomie et des décennies d'enseignement à tous les niveaux du jeu.`)
};

const vi_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương pháp Egly: sáu bước có cơ sở khoa học để swing golf tốt hơn, dựa trên vật lý, giải phẫu học và nhiều thập kỷ giảng dạy ở mọi trình độ.`)
};

const sw_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mbinu ya Egly: hatua sita za kisayansi kuelekea swing bora ya gofu, zinazotokana na fizikia, anatomia na miongo ya ufundishaji katika kila ngazi ya mchezo.`)
};

const th_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิธี Egly: หกขั้นตอนตามหลักวิทยาศาสตร์เพื่อวงสวิงกอล์ฟที่ดีขึ้น โดยมีพื้นฐานมาจากฟิสิกส์ กายวิภาคศาสตร์ และการสอนมานานหลายทศวรรษในทุกระดับของเกม`)
};

const bs_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly metoda: šest koraka zasnovanih na nauci do boljeg golf zamaha, utemeljenih u fizici, anatomiji i decenijama poučavanja na svim nivoima igre.`)
};

const ja_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method：物理学、解剖学、そしてあらゆるレベルでの数十年にわたる指導に基づく、より良いゴルフスイングのための6つの科学的ステップ。`)
};

const ko_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly 메서드: 물리학과 해부학, 그리고 모든 수준의 게임에서 쌓아온 수십 년의 가르침을 바탕으로 한, 더 나은 골프 스윙을 위한 여섯 가지 과학 기반 단계.`)
};

const pt_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Método Egly: seis passos científicos para um swing de golfe melhor, fundamentados em física, anatomia e décadas de ensino em todos os níveis do jogo.`)
};

const it_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Metodo Egly: sei passi basati sulla scienza per uno swing migliore, fondati su fisica, anatomia e decenni di insegnamento a ogni livello di gioco.`)
};

const sv_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method: sex vetenskapsbaserade steg till en bättre golfsving, grundade i fysik, anatomi och årtionden av undervisning på alla nivåer i spelet.`)
};

const nl_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method: zes wetenschappelijk onderbouwde stappen naar een betere golfswing, gebaseerd op natuurkunde, anatomie en tientallen jaren lesgeven op elk niveau van het spel.`)
};

const da_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method: seks videnskabeligt funderede trin til et bedre golfsving, baseret på fysik, anatomi og årtiers undervisning på alle niveauer af spillet.`)
};

const nb_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method: seks vitenskapsbaserte steg til en bedre golfsving, forankret i fysikk, anatomi og flere tiår med undervisning på alle nivåer av spillet.`)
};

const fi_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method: kuusi tieteeseen perustuvaa askelta parempaan golfsvingiin. Pohjana fysiikka, anatomia ja vuosikymmenten opetuskokemus pelin kaikilla tasoilla.`)
};

const pl_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoda Egly: sześć opartych na nauce kroków do lepszego swingu, wynikających z fizyki, anatomii i dziesięcioleci nauczania na każdym poziomie gry.`)
};

const ru_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метод Egly: шесть научно обоснованных шагов к лучшему свингу, основанных на физике, анатомии и десятилетиях преподавания на всех уровнях игры.`)
};

const tr_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method: fizik, anatomi ve oyunun her seviyesinde onlarca yıllık eğitim deneyimine dayanan, daha iyi bir golf swing’i için bilime dayalı altı adım.`)
};

const hi_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method: बेहतर गोल्फ स्विंग के लिए छह विज्ञान-आधारित कदम, जो भौतिकी, शरीर रचना और खेल के हर स्तर पर दशकों के शिक्षण अनुभव पर आधारित हैं।`)
};

const id_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method: enam langkah berbasis sains menuju ayunan golf yang lebih baik, berlandaskan fisika, anatomi, dan puluhan tahun pengalaman mengajar di semua tingkat permainan.`)
};

const ms_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method: enam langkah berasaskan sains untuk hayunan golf yang lebih baik, berlandaskan fizik, anatomi dan berdekad-dekad pengajaran di setiap peringkat permainan.`)
};

const cs_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method: šest vědecky podložených kroků k lepšímu golfovému švihu, zakotvených ve fyzice, anatomii a desetiletích výuky na každé úrovni hry.`)
};

const el_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η Μέθοδος Egly: έξι επιστημονικά τεκμηριωμένα βήματα για καλύτερο σβινγκ στο γκολφ, βασισμένα στη φυσική, την ανατομία και σε δεκαετίες διδασκαλίας σε κάθε επίπεδο του παιχνιδιού.`)
};

const he_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיטת Egly: שישה צעדים מבוססי מדע לסווינג גולף טוב יותר, הנשענים על פיזיקה, אנטומיה ועשרות שנות הוראה בכל רמות המשחק.`)
};

const af_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-metode: ses wetenskaplike stappe na 'n beter gholfswing, gegrond in fisika, anatomie en dekades van onderrig op elke vlak van die spel.`)
};

const hu_method_meta_description = /** @type {(inputs: Method_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Egly Method: hat tudományos alapú lépés a jobb golflendítéshez, amely a fizikára, az anatómiára és a játék minden szintjén szerzett évtizedes oktatói tapasztalatra épül.`)
};

/**
* | output |
* | --- |
* | "The Egly Method: six science-based steps to a better golf swing, grounded in physics, anatomy, and decades of teaching at every level of the game." |
*
* @param {Method_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_meta_description = /** @type {((inputs?: Method_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_meta_description(inputs)
	if (locale === "de") return de_method_meta_description(inputs)
	if (locale === "zh") return zh_method_meta_description(inputs)
	if (locale === "ar") return ar_method_meta_description(inputs)
	if (locale === "fr") return fr_method_meta_description(inputs)
	if (locale === "vi") return vi_method_meta_description(inputs)
	if (locale === "sw") return sw_method_meta_description(inputs)
	if (locale === "th") return th_method_meta_description(inputs)
	if (locale === "bs") return bs_method_meta_description(inputs)
	if (locale === "ja") return ja_method_meta_description(inputs)
	if (locale === "ko") return ko_method_meta_description(inputs)
	if (locale === "pt") return pt_method_meta_description(inputs)
	if (locale === "it") return it_method_meta_description(inputs)
	if (locale === "sv") return sv_method_meta_description(inputs)
	if (locale === "nl") return nl_method_meta_description(inputs)
	if (locale === "da") return da_method_meta_description(inputs)
	if (locale === "nb") return nb_method_meta_description(inputs)
	if (locale === "fi") return fi_method_meta_description(inputs)
	if (locale === "pl") return pl_method_meta_description(inputs)
	if (locale === "ru") return ru_method_meta_description(inputs)
	if (locale === "tr") return tr_method_meta_description(inputs)
	if (locale === "hi") return hi_method_meta_description(inputs)
	if (locale === "id") return id_method_meta_description(inputs)
	if (locale === "ms") return ms_method_meta_description(inputs)
	if (locale === "cs") return cs_method_meta_description(inputs)
	if (locale === "el") return el_method_meta_description(inputs)
	if (locale === "he") return he_method_meta_description(inputs)
	if (locale === "af") return af_method_meta_description(inputs)
	if (locale === "hu") return hu_method_meta_description(inputs)
	return en_method_meta_description(inputs)
});